<template>
  <v-container ma-0 pa-0 fluid style="height:100%;" class="pt-sans">
      <sub-tabs nomeSessao="Minha Conta" :tabs="tabs"></sub-tabs>
  </v-container>
</template>

<script>
import subTabs from '@/components/painel/SubTabs'
export default {
  name: 'PCadastro',
  components: {
    'sub-tabs': subTabs
  },
  data () {
    return {
      tabs: [
        {
          nome: 'Perfil da empresa',
          url: 'Empresa'
        },
        {
          nome: 'Minhas avaliações',
          url: 'Avaliacoes'
        },
        {
          nome: 'Usuários',
          url: 'Usuarios'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?d1d18904